import React, { useState } from 'react'
import CustomModal from 'components/global/CustomModal'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import { Avatar } from 'antd'
import { convertToUtc, getNameSignature } from 'helper/utility'
import { StatusLabelCheckin } from '../CheckInOut/Content/StatusLabel'
import { StatusList } from '../CheckInOut/constants'
import { infoMessage } from 'api/global'
import { useParams } from 'react-router-dom'
import { useAddDropInAttendeeToFamily } from 'api/Event/Dropin'
import AddMember from './AddMember'

const FamilyFound = () => {
  const { id }: { id: string } = useParams()
  const [addFamilyMemberModal, setAddFamilyMemberModal] = useState(false)
  const {
    accountFoundModalOpen,
    setAccountFoundModalOpen,
    checkInFamilyMembers,
    participantData,
    setDetailedDropOutModalOpen,
    setParticipantData,
    setAddNewMemberModalOpen,
    setFamilyId,
  } = eventAttendanceStore(store => ({
    accountFoundModalOpen: store.accountFoundModalOpen,
    setAccountFoundModalOpen: store.setAccountFoundModalOpen,
    checkInFamilyMembers: store.checkInFamilyMembers,
    participantData: store.participantData,
    setDetailedDropOutModalOpen: store.setDetailedDropOutModalOpen,
    setParticipantData: store.setParticipantData,
    setAddNewMemberModalOpen: store.setAddNewMemberModalOpen,
    setFamilyId: store.setFamilyId,
  }))

  const {
    mutate: dropInAttendeeAddMutation,
    isLoading: dropInAttendeeMutationLoading,
  } = useAddDropInAttendeeToFamily()

  const closeModal = () => {
    setAccountFoundModalOpen(false)
  }

  const handleClick = member => {
    if (member.status === 'checked-in') {
      return infoMessage('This member is already checked-in')
    } else {
      const payload = {
        dropInAttendeeId: participantData._id,
        familyId: member.familyId,
        [`${member.type}Id`]: member._id,
        eventId: id,
        checkInId: participantData.checkInId,
        date: convertToUtc(new Date()),
      }
      dropInAttendeeAddMutation(payload, {
        onSuccess: data => {
          setParticipantData({ ...participantData, ...data })
          setDetailedDropOutModalOpen(true)
          setAccountFoundModalOpen(false)
        },
      })
    }
  }

  const handleAddMember = () => {
    setAddNewMemberModalOpen(true)
    setFamilyId(checkInFamilyMembers[0].familyId)
    // setAccountFoundModalOpen(false)
  }

  return (
    <CustomModal
      openModal={accountFoundModalOpen}
      isCloseModalCustom={true}
      closeModal={closeModal}
      title="Family Found"
      width={600}
      footer={false}
    >
      <>
        {checkInFamilyMembers.map((member: any) => {
          return (
            <div
              className="flex gap-16px align-center justify-between mt-20px pointer"
              key={member._id}
              onClick={() => handleClick(member)}
            >
              <div className="flex align-center gap-16px">
                <Avatar size={40} src={member.photo?.post}>
                  {getNameSignature(`${member.firstName} ${member.lastName}`)}
                </Avatar>
                <h2 className="text-16 w-500">{`${member.firstName} ${member.lastName}`}</h2>
              </div>

              {member.status === 'checked-in' && (
                <div
                  style={{
                    backgroundColor: StatusList[3].color,
                  }}
                  className="flex flex-center justify-center px-15px py-10px radius-12 ml-15px pointer"
                >
                  <>
                    <img src={StatusList[3].img} alt={StatusList[3].value} />
                    <h4 className="ml-10px text-12 w-600">
                      {StatusList[3].title}
                    </h4>
                  </>
                </div>
              )}
            </div>
          )
        })}

        <div className="mt-40px flex align-center justify-center">
          <button className="borderd-btn w-full" onClick={handleAddMember}>
            None of these
          </button>
        </div>
      </>
    </CustomModal>
  )
}

export default FamilyFound
